import { render, staticRenderFns } from "./sample_page.vue?vue&type=template&id=6344b484&"
import script from "./sample_page.vue?vue&type=script&lang=js&"
export * from "./sample_page.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports